import gql from 'graphql-tag'

export const GET_FORMATTED_CITATIONS = gql`
  query GetFormattedCitations(
    $projectId: String!
    $style: String!
    $order: Order = desc
    $limit: Int = 500
    $page: Int = 1
  ) {
    formattedCitations(
      projectId: $projectId
      style: $style
      order: $order
      limit: $limit
      page: $page
    ) {
      projectId
      citationId
      createdAt
      annotation
      data
      formattedData {
        citation
        footnote
      }
      contributors {
        first
        middle
        last
        function
        data
      }
    }
  }
`

export const GET_FORMATTED_FOOTNOTE = gql`
  query GetFormattedFootnote($projectId: String!, $citationId: String!, $style: String!) {
    formattedCitationFootnote(
      projectId: $projectId
      citationId: $citationId
      style: $style
    ) {
      footnote
    }
  }
`

export const GET_CITATION_NOTES = gql`
  query GetCitationNotes($projectId: String!, $citationId: String!) {
    comments(projectId: $projectId, citationId: $citationId) {
      id
      createdAt
      fullName
      text
    }
  }
`
